import React from "react";
import { useNavigate } from "react-router-dom";
import CphereHeaderLogo from "../components/CphereHeaderLogo";
import { AdvertiserIdentityTrigger, GovernedAdvertiserSelectorModal } from "../components/GovernedAdvertiserSelector";
import useGovernedAdvertiserCatalog from "../hooks/useGovernedAdvertiserCatalog";
import YahooDspReporting from "../components/YahooDspReporting";
import AnalyticsHeroPlatformLogo from "../components/AnalyticsHeroPlatformLogo";
import "./PlatformAnalyticsExperience.css";
import "./YahooAnalytics.css";

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL ||
  (process.env.NODE_ENV === "production" ? "https://cphere-backend.onrender.com" : "");
const ROLE = "client";

export default function YahooAnalytics() {
  const navigate = useNavigate();
  const { selectedAdvertiserId, visibleAdvertisers, currentAdvertiser, loading, errorMessage,
    selectorDisabled, selectorEmpty, modalOpen, openSelector, closeSelector, handleAdvertiserSelect,
  } = useGovernedAdvertiserCatalog({ apiBase: API_BASE_URL, role: ROLE });
  const advertiserId = currentAdvertiser?.id ?? null;
  return <div className="core-dashboard ppx-page-container yahoo-analytics-page">
    <div className="core-dashboard-content ppx-page-content cortex-page-intro-shell">
      <CphereHeaderLogo alt="Powered by Logo" className="ppx-brand-logo" onClick={() => navigate("/dashboard")} style={{ cursor: "pointer" }} />
      <div className="cphere-governed-hero-selector-stack ppx-governed-selector-stack">
        <div className="ppx-hero-container">
          <h1 className="ppx-hero-pill yahoo-analytics-title">
            <AnalyticsHeroPlatformLogo platformKey="yahoo" />
            <span className="ppx-hero-pill-label cphere-hero-pill-wordmark">Yahoo</span>
            <span className="ppx-hero-pill-tag cphere-hero-pill-tag">Analytics</span>
          </h1>
          <div className="ppx-hero-shimmer-bar" aria-hidden="true" />
        </div>
        <div className="cphere-governed-advertiser-selector-stage">
          <AdvertiserIdentityTrigger advertiser={currentAdvertiser} advertiserName={currentAdvertiser?.name || ""} apiBase={API_BASE_URL}
            disabled={selectorDisabled} loading={loading} empty={selectorEmpty} modalOpen={modalOpen} onClick={openSelector} />
        </div>
      </div>
      {modalOpen && <GovernedAdvertiserSelectorModal advertisers={visibleAdvertisers} selectedAdvertiserId={selectedAdvertiserId}
        selectedAdvertiserName={currentAdvertiser?.name || ""} apiBase={API_BASE_URL} onSelect={handleAdvertiserSelect} onClose={closeSelector} />}
      <main className="ppx-analytics-shell" aria-label="Yahoo analytics">
        <nav className="ppx-filter-row" aria-label="Yahoo analytics navigation">
          <button type="button" className="ppx-chip" onClick={() => navigate("/programmatic-analytics")}>Omni Analytics</button>
          <button type="button" className="ppx-chip" onClick={() => navigate("/integrations#yahoo-dsp")}>Yahoo connection settings</button>
        </nav>
        {errorMessage ? <div className="ppx-state-panel" role="alert"><h2 className="ppx-state-title">Advertiser access unavailable</h2><p className="ppx-state-body">{errorMessage}</p></div>
          : <YahooDspReporting key={String(advertiserId || "none")} apiBase={API_BASE_URL} advertiserId={advertiserId} role={ROLE} />}
      </main>
    </div>
  </div>;
}
